// *COVR REACT APP*
// `covrReactApp` This is the data passed from WP to React App
// you can find this in the
// `public/class-covr-react-app-public.php` line 122
// Attr: Add more as we go
// - blocks: are blocks from wp gutenberg layout builder
// - type: `parts | page` if `page` just spit out
//  entire page if not do your demo functionality spit out `parts`;

import { decode } from "html-entities";

const covrReactApp = window?.covrReactApp || {
    ID: 0,
    title: '',
    slug: '',
    link: '',
    date: '',
    color: '',
    breadcrumbs: [],
    ads: [],
    image: {
        src: '',
        focalPoint: {
            top: 50,
            left: 50,
        }
    },
    pagination: {
        previous: { name: '', title: '' },
        next: { name: '', title: '' },
    },
    blocks: [],
    type: null,
    root: '',
    nonce: '',
    domain: '',
    mediaRoot: '',
    template: '',
    taxonomy: '',
};

export const getWordpressVars = () => {
    return {
        ...covrReactApp,
        title: decode(covrReactApp.title),
    }
};

export const getWordpressVar = (key) => covrReactApp[key];

export const getWordpressUrl = (reactUrl: string) => getWordpressVar('mediaRoot') + reactUrl;
